import React, { useContext, useEffect, useMemo, useState } from 'react'
import { FMIStudentProfileContext } from './context'
import Error from '@components/Error'
import MyBerlitzLessons from '@classes/Lessons'
import moment from 'moment'
import { useLazyQuery } from '@apollo/react-hooks'
import { GET_SCHEDULES_PER_PROGRAM } from '@queries/schedules'
import ScheduleInstructors from '.'
import InstructorsLoader from './InstructorsLoader'

const InstructorsWrapper: React.FC = () => {
  const [sessions, setSessions] = useState<MyBerlitzLessons>()
  const { userProfileLoading, userProfileError, userProfile, StudentPrograms } = useContext(FMIStudentProfileContext)

  const [getSessions, { loading: getSessionLoading, error: getSessionError, data: sessionData }] = useLazyQuery(
    GET_SCHEDULES_PER_PROGRAM
  )

  useEffect(() => {
    try {
      if (userProfile && StudentPrograms?.Programs?.length) {
        getSessions({
          variables: {
            Id: userProfile?.SFId,
            FromDate: moment()
              .subtract(5, 'years')
              .toISOString(),
            EndDate: moment().toISOString(),
            ProgramIds: StudentPrograms?.Programs.map(Program => Program.ProgramId).join(','),
            UserId: userProfile?.SFId
          },
        })
      }
    } catch (e) {
      console.error(e)
    }
  }, [userProfile?.SFId, StudentPrograms])

  useEffect(() => {
    if (sessionData) {
      setSessions(new MyBerlitzLessons(sessionData?.getSchedulesId || []))
    }
  }, [sessionData])

  const Component = useMemo(
    () => (userProfile ? <ScheduleInstructors loading={getSessionLoading} sessions={sessions} isAdmin /> : null),
    [userProfile, getSessionLoading, sessions]
  )

  return (
    <>
      {userProfileError || getSessionError ? (
        <Error statusCode="400" />
      ) : userProfileLoading ? (
        <InstructorsLoader />
      ) : (
        Component
      )}
    </>
  )
}

export default InstructorsWrapper
